import Vue from 'vue';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';
import Notify from 'klicknotify';

import store from './store';
import router from './router';

import * as RouterWatcher from './router/watcher';
import * as TokenRequest from './helpers/request/token';

Vue.use(VueRouter);

TokenRequest.autoUpdate();

sync(store, router);
RouterWatcher.setup(router, store);

Notify.init();

export {
  store,
  router,
};



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/